/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Způsob dopravy`
};

const da_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Leveringsmetode`
};

const de_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Versandart`
};

const en_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Shipping method`
};

const es_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Método de envío`
};

const fr_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Mode de livraison`
};

const hu_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítási mód`
};

const it_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Metodo di spedizione`
};

const nl_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Verzendmethode`
};

const pl_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Metoda dostawy`
};

const pt_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Método de envio`
};

const sv_shipping_method = /** @type {(inputs: {}) => string} */ () => {
	return `Leveranssätt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_method = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_method(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_method", locale)
	if (locale === "cs") return cs_shipping_method(inputs)
	if (locale === "da") return da_shipping_method(inputs)
	if (locale === "de") return de_shipping_method(inputs)
	if (locale === "en") return en_shipping_method(inputs)
	if (locale === "es") return es_shipping_method(inputs)
	if (locale === "fr") return fr_shipping_method(inputs)
	if (locale === "hu") return hu_shipping_method(inputs)
	if (locale === "it") return it_shipping_method(inputs)
	if (locale === "nl") return nl_shipping_method(inputs)
	if (locale === "pl") return pl_shipping_method(inputs)
	if (locale === "pt") return pt_shipping_method(inputs)
	return sv_shipping_method(inputs)
};